<template>
  <div>
    <authnavbar />
    <div class="center-content authbody">
      <img src="../../assets/images/authImage.png" alt="background" class="authback"/>
        <div class="has-text-centered">
          <img src="../../assets/images/virtualred-logo/reduzido/logo-reduzido-gradiente-3x.png" alt="Logo" class="main-logo" />
          <p>Acesse sua conta</p>
        </div>
      <div class="login-box">
        <form @submit.prevent="validate">
          <b-field
            label="password"
            :type="{'is-danger': errors.has('password')}"
            :message="errors.first('password')"
          >
            <b-input
              v-validate="'required'"
              v-model="request.password"
              type="password"
              password-reveal
              name="password"
            ></b-input>
          </b-field>

          <b-field
            label="password_confirmation"
            :type="{'is-danger': errors.has('password_confirmation')}"
            :message="errors.first('password_confirmation')"
          >
            <b-input
              v-validate="'required'"
              v-model="request.password_confirmation"
              type="password"
              password-reveal
              name="password_confirmation"
            ></b-input>
          </b-field>

          <button
            type="submit"
            class="button is-primary is-fullwidth"
            :class="{'is-loading': isLoading}"
          >Trocar a Senha</button>

          <router-link
            :to="{name: 'login'}"
            style="margin-top:20px;"
            class="is-block has-text-centered"
          >login</router-link>
        </form>
      </div>
    </div>

    <authfooter />
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import authnavbar from "@/components/Navbars/AuthNav";
import authfooter from "@/components/Footers/AuthFooter";

export default {
  name: "ResetPassword",
  created() {
    AuthService.ValidateRequestPassword(this.$route.params.token)
      .then(response => {
        this.request = response.data;
      })
      .catch(() => this.$router.push({ name: "login" }));
  },
  components: {
    authnavbar: authnavbar,
    authfooter: authfooter
  },

  methods: {
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) this.reset();
      });
    },

    reset() {
      this.isLoading = true;
      AuthService.ResetPassword(this.request)

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Senha alterada com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
          this.$router.push({ name: "login" });
        })

        .catch(() => {})

        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  data() {
    return {
      request: {
        password: "",
        password_confirmation: ""
      },
      isLoading: false
    };
  }
};
</script>